import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";

interface Props {
  minWidth?: string;
  maxWidth?: string;
  children: ReactNode;
}

const Responsive: React.FC<Props> = ({ minWidth, maxWidth, children }) => {
  const mediaQuery = useMemo(() => {
    const minWidthQuery = minWidth && `(min-width: ${minWidth})`;
    const maxWidthQuery = maxWidth && `(max-width: ${maxWidth})`;

    return [minWidthQuery, maxWidthQuery].filter((query) => query).join(" and ");
  }, [maxWidth, minWidth]);

  const mediaQueryList = useMemo(() => window.matchMedia(mediaQuery), [mediaQuery]);

  const [shouldRender, setShouldRender] = useState(mediaQueryList.matches);

  const windowWidthChangeHandler = useCallback((event: MediaQueryListEvent) => {
    setShouldRender(event.matches);
  }, []);

  useEffect(() => {
    mediaQueryList.addEventListener("change", windowWidthChangeHandler);

    return () => {
      mediaQueryList.removeEventListener("change", windowWidthChangeHandler);
    };
  }, [mediaQueryList, windowWidthChangeHandler]);

  return shouldRender ? <>{children}</> : null;
};

export default Responsive;
